// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer-wrapper" style={{ padding: "10px 0", background: "#1a1a1a", color: "#fff" }}>
      <div className="footer-inner" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        
        {/* Brokerage name (required) */}
        <div style={{ marginBottom: "20px", fontSize: "15px", opacity: 0.9 }}>
          © {new Date().getFullYear()} Platinum Palm Properties LLC. All rights reserved.
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {/* Equal Housing */}
          <img
            src="/assets/equal-housing.png"
            alt="Equal Housing Opportunity"
            style={{ height: "50px", width: "auto" }}
          />

          {/* Realtor® */}
          <img
            src="/assets/realtor.png"
            alt="Realtor"
            style={{ height: "50px", width: "auto" }}
          />
        </div>

      </div>
    </footer>
  );
}
